import { render, staticRenderFns } from "./TwTableColumnSetting.vue?vue&type=template&id=60e2ae0c&scoped=true&"
import script from "./TwTableColumnSetting.vue?vue&type=script&lang=js&"
export * from "./TwTableColumnSetting.vue?vue&type=script&lang=js&"
import style0 from "./TwTableColumnSetting.vue?vue&type=style&index=0&id=60e2ae0c&lang=scss&scoped=true&"
import style1 from "./TwTableColumnSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2ae0c",
  null
  
)

export default component.exports